export default __webpack_public_path__ + "static/media/goeducate-gradient.62c86cd6.png";